module.exports = __webpack_public_path__ + "img/gzsrm.58d923c9.png";